module.exports = __webpack_public_path__ + "static/media/UniNeueBlack-Italic.b6546df5.eot";